import React, { Component } from 'react';
import './CustomCheckSelector.css'
import {injectIntl} from "react-intl";
import { addItemSelect, removeItemSelect } from "../../actions/MultiselectAction";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class CustomCheckSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSelected: false,
    }
  }

  componentDidMount = () => {
    this.handleSelectExistingItem();
  }

  componentDidUpdate(prevProps) {
    if(this.props.selectedFiles.length === 0 && prevProps.selectedFiles.length !== 0){
      this.setState({
        isSelected: false,
      })
      return;
    }
    if(this.props.selectedFiles.length > prevProps.selectedFiles.length){
      this.props.selectedFiles.forEach((e)=>{
        const exist = this.props.selectedFiles.some(item => item._id === this.props.itemHover._id);
        if(exist && !this.state.isSelected){
          this.setState({
            isSelected: true,
          })
        }
      })
    }
  }

  handleSelectItem = (e) => {
    e.stopPropagation();
    const { addItemSelect, removeItemSelect, itemHover, keyCollection} = this.props;
    if (!this.state.isSelected) {
      addItemSelect(itemHover, keyCollection);
    } else {
      removeItemSelect(itemHover, keyCollection);
    }
    this.setState({
      isSelected: !this.state.isSelected,
    })
  }

  handleSelectExistingItem = () => {
    const { selectedFiles, itemHover } = this.props;
    const exist = selectedFiles.some(item => item._id === itemHover._id);
    this.setState({
      isSelected: exist,
    })
  }

  render() {
    const { isSelected } = this.state;
    const {
      isHover,
      k,
      indice,
      selectedFiles,
      itemHover,
      from,
      inList,
      folderOrBunker,
      newColor
    } = this.props;

    if ((isHover && `${from}-${k}` === indice) || selectedFiles.some(x => x._id === itemHover._id)) return (
      <div
        onMouseEnter={this.props.handleOnMouseEnter}
        onMouseLeave={this.props.handleOnMouseLeave}
      >
        <div 
          className={`custom-select ${isSelected ? "open" : ""}`} 
          onClick={this.handleSelectItem}
          style = {{
            top: inList ? "12px" : "5px",
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: folderOrBunker ? "white": newColor
          }}
        >
          
          </div>
      </div>
    )
    else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFiles: state.selectedFiles.data,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
  addItemSelect,
  removeItemSelect,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomCheckSelector)))
